import { render, staticRenderFns } from "./SelectFiles.vue?vue&type=template&id=044fa68b&"
import script from "./SelectFiles.vue?vue&type=script&lang=js&"
export * from "./SelectFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('044fa68b')) {
      api.createRecord('044fa68b', component.options)
    } else {
      api.reload('044fa68b', component.options)
    }
    module.hot.accept("./SelectFiles.vue?vue&type=template&id=044fa68b&", function () {
      api.rerender('044fa68b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileStorage/SelectFiles.vue"
export default component.exports